import CoreBase from '../../../../../services/engines/CoreBase';
import tabEngine from '../../../TabEngine/TabEngine';
import searchQueryEngine from '../../../YourSearchTab/Core/SearchQueryEngine';

class SearchHandler extends CoreBase {
    _name = 'SearchHandler';

    /**
     * Handles jerny:search — navigeert naar search tab en zet query.
     * Conform IframeRenderer jerny:search handler.
     * @param {MessageEvent} e
     */
    handle = (e) => {
        try {
            const query = e.data?.query;
            if (!query) return;

            const index = tabEngine.getIndexById('search');
            if (index !== -1) tabEngine.setTab(index);
            searchQueryEngine.setQuery(query);
        } catch (error) {
            this.logError('handle', error.message);
        }
    };
}

const searchHandler = new SearchHandler();
export default searchHandler;
